require('../modules/es7.array.includes');
module.exports = require('../modules/_core').Array;


//////////////////
// WEBPACK FOOTER
// /Users/alexandre/Documents/web/riberfuso/resources/ng/~/core-js/es7/array.js
// module id = ../../../../core-js/es7/array.js
// module chunks = 5